import ActionTypes from './actionTypes'

export const hideNotifications = () => ({
  type: ActionTypes.HIDE_NOTIFICATIONS,
})

export const createNotification = (notification) => ({
  type: ActionTypes.CREATE_NOTIFICATION,
  payload: notification,
})

export const createErrorNotification = (notification) => ({
  type: ActionTypes.CREATE_NOTIFICATION,
  payload: {
    type: 'error',
    message: notification,
  },
})

export const createInfoNotification = (notification) => ({
  type: ActionTypes.CREATE_NOTIFICATION,
  payload: {
    message: notification,
  },
})

export const createSuccessNotification = (notification) => ({
  type: ActionTypes.CREATE_NOTIFICATION,
  payload: {
    type: 'success',
    message: notification,
  },
})
